import React, { useRef, useState } from 'react'
import './DataSet.css'
import DataSetBox from './DataSetBox'

export default function DataSet() {

    const [isMouseDown, setIsMouseDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const containerRef = useRef(null);

    const onMouseDown = (e) => {
        setIsMouseDown(true);
        setStartX(e.clientX - containerRef.current.offsetLeft);
        setScrollLeft(containerRef.current.scrollLeft);
    };

    const onMouseLeave = () => {
        setIsMouseDown(false);
    };

    const onMouseUp = () => {
        setIsMouseDown(false);
    };

    const onMouseMove = (e) => {
        if (!isMouseDown) return;
        const x = e.clientX - containerRef.current.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        containerRef.current.scrollLeft = scrollLeft - walk;
    };

    const datasets = [
        {
            datasetName: "Hospitality_Data_Global_fct.csv",
            datasetDesc: "Main transactional fact table containing guest stay details, room bookings, demographics, stay duration, hotel information, payment method, and loyalty membership data.",
            image: "/datasetImage1.png"
        },
        {
            datasetName: "Hotel_List.xlsx",
            datasetDesc: "Contains master data for all hotel properties including hotel name, city, and hotel category/type.",
            image: "/datasetImage2.png"
        },
        {
            datasetName: "Manager_Details.xlsx",
            datasetDesc: " Contains hotel manager information such as manager ID, manager name, email, and associated hotel property.",
            image: "/datasetImage3.png"
        },
        {
            datasetName: "OnlineBooking_dim.csv",
            datasetDesc: " Contains online booking transaction details including booking channel, booking date, customer email, selected location, and device type used for booking.",
            image: "/datasetImage4.png"
        },
        {
            datasetName: "Feedback_dim.csv",
            datasetDesc: "Contains customer feedback and satisfaction data including overall ratings, staff ratings, cleanliness ratings, and textual feedback.",
            image: "/datasetImage5.png"
        },
        {
            datasetName: "Finance_dim.csv",
            datasetDesc: " Contains financial metrics related to hotel bookings including revenue, operational costs, discounts, additional service revenue, and payment mode.",
            image: "/datasetImage6.png"
        }

    ]
    return (
        <div>
            <p className='DatasetHeading'>DATA SET</p>
            <p className='DatasetIntro'>Participants will be provided with a comprehensive collection of datasets covering various aspects of event
                management. These datasets capture key details on event organization, participation, location-based insights,
                category performance, and attendee engagement. The datasets include
                :</p>

            <div className='allDatasets' ref={containerRef}
                onMouseDown={onMouseDown}
                onMouseLeave={onMouseLeave}
                onMouseUp={onMouseUp}
                onMouseMove={onMouseMove}>
                {
                    datasets?.map((e, id) => {
                        return (
                            <DataSetBox key={id} datasetName={e?.datasetName} datasetDesc={e?.datasetDesc} image={e?.image} />
                        )
                    })
                }
            </div>

            <div className='additionalInfoSection'>
                <p className='additionalText'>To ensure participants can effectively work with the data, the following resources
                    will also be provided:</p>
                <ul>
                    <li className='additionalText'><span style={{ color: "black" }}>Data Dictionary : </span> Contains the structure, definitions, and
                        relationships within the datasets.</li>
                    <li className='additionalText'><span style={{ color: "black" }}>BRD, General Instructions : </span> A step-by-step document detailing the procedural
                        guidelines for the submission of entries, ensuring a seamless and efficient submission process.</li>
                </ul>
            </div>

        </div>
    )
}
